import { useEffect, useRef } from "react";
import Parallax from "parallax-js";
import { Link } from "react-router-dom";

export default function FooterCta() {
  const sceneRef = useRef(null);

  useEffect(() => {
    if (sceneRef.current) {
      const parallaxInstance = new Parallax(sceneRef.current);
      // Cleanup the parallax instance on component unmount
      return () => {
        parallaxInstance.disable();
      };
    }
  }, []);
  return (
    <section className="md:mb-[-153px]">
      <div className="w-full mx-auto theme-container px-4">
        <div
          className="grid grid-cols-6 gap-5 md:grid-cols-10 rounded-xl py-10 md:py-[70px] px-5 md:px-[110px] relative"
          style={{
            backgroundImage: "url('/assets/images/Background.svg')",
            backgroundSize: "cover",
          }}
        >
          <div className="relative z-10 col-span-6">
            <div className="mb-6">
              <h2 className="text-white font-semibold text-20 sm:text-34 md:text-48 max-w-[449px]">
                Ready to begin your next project?
              </h2>
            </div>
            <p className="mb-8 sm:mb-10 text-white text-16 sm:text-18">
            Turbocharge enterprise transformation through Process Automation and AI.
            </p>

            <Link href="" className="">
              <div className="group w-fit bg-white px-6 sm:px-10 h-12 sm:h-[56px] flex justify-center items-center gap-2 sm:gap-2.5 rounded-[40px] relative price_button_bg before:inline-block before:absolute before:w-full before:h-full before:scale-x-0 hover:before:scale-x-100 overflow-hidden before:transition-transform before:ease-out before:duration-300 before:origin-right hover:before:origin-left before:z-0">
                <span className="relative z-10 font-semibold transition-all duration-300 font-inter text-purple group-hover:text-white text-sm sm:text-base">
                  Start your journey today
                </span>
                <svg
                  className="relative z-10"
                  width="7"
                  height="12"
                  viewBox="0 0 7 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="transition-all duration-300 group-hover:stroke-white"
                    d="M1 10.5L4.79289 6.70711C5.12623 6.37377 5.29289 6.20711 5.29289 6C5.29289 5.79289 5.12623 5.62623 4.79289 5.29289L1 1.5"
                    stroke="#794AFF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
